var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasTeam
    ? _c("div", { staticClass: "md-layout" }, [
        _c(
          "div",
          {
            staticClass:
              "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
          },
          [
            _c("div", { staticClass: "custom-toolbar" }, [
              _c(
                "div",
                { staticClass: "custom-toolbar-start" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "Team Settings" } } },
                    [
                      _c("h3", { staticClass: "title" }, [
                        _vm._v("Team Settings"),
                      ]),
                    ]
                  ),
                  _c("h3", { staticClass: "title" }, [
                    _vm._v("   >    " + _vm._s(_vm.$t("menus.setting.tags"))),
                  ]),
                ],
                1
              ),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "md-layout-item md-size-100" },
          [
            _c(
              "md-card",
              [
                _c(
                  "md-card-header",
                  { staticClass: "md-card-header-icon md-card-header-blue" },
                  [
                    _c(
                      "div",
                      { staticClass: "card-icon" },
                      [_c("md-icon", [_vm._v("tag")])],
                      1
                    ),
                  ]
                ),
                _c("md-card-content", [
                  _c(
                    "div",
                    { staticClass: "cf-container" },
                    [
                      _c(
                        "div",
                        { staticClass: "cf-action-container" },
                        [
                          _c(
                            "md-switch",
                            {
                              staticClass: "custom-switch",
                              model: {
                                value: _vm.showDeletedTags,
                                callback: function ($$v) {
                                  _vm.showDeletedTags = $$v
                                },
                                expression: "showDeletedTags",
                              },
                            },
                            [_vm._v("Deleted tags")]
                          ),
                          _c(
                            "md-button",
                            {
                              staticClass: "md-primary md-just-icon md-round",
                              attrs: { title: "Add Tag" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleAddTag()
                                },
                              },
                            },
                            [_c("md-icon", [_vm._v("add")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "md-table",
                        { staticClass: "custom-paginated-table" },
                        [
                          _c(
                            "md-table-row",
                            [
                              _c("md-table-head", [_vm._v("Name")]),
                              _c("md-table-head", [_vm._v("In Use")]),
                              _c("md-table-head", [_vm._v("Actions")]),
                            ],
                            1
                          ),
                          _vm._l(_vm.tagList, function (tag, index) {
                            return _c(
                              "md-table-row",
                              { key: index },
                              [
                                _c("md-table-cell", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(tag.name) +
                                      "\n                            "
                                  ),
                                ]),
                                _c(
                                  "md-table-cell",
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(tag.totalTagCount) +
                                        "\n                                "
                                    ),
                                    tag.customerTagCount > 0 ||
                                    tag.teamMemberTagCount > 0 ||
                                    tag.adjustmentTagCount > 0
                                      ? _c(
                                          "md-tooltip",
                                          {
                                            staticClass: "tooltip-container",
                                            attrs: { "md-direction": "left" },
                                          },
                                          [
                                            tag.customerTagCount > 0
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                                        Customers: " +
                                                      _vm._s(
                                                        tag.customerTagCount
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            tag.teamMemberTagCount > 0
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                                        Team members: " +
                                                      _vm._s(
                                                        tag.teamMemberTagCount
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            tag.adjustmentTagCount > 0
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                                        Adjustments: " +
                                                      _vm._s(
                                                        tag.adjustmentTagCount
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "md-table-cell",
                                  { staticClass: "action-buttons" },
                                  [
                                    tag.isDeleted
                                      ? _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-success md-just-icon md-round",
                                            attrs: { title: "enable tag" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.enableTag(tag)
                                              },
                                            },
                                          },
                                          [_c("md-icon", [_vm._v("add")])],
                                          1
                                        )
                                      : _vm._e(),
                                    !tag.isDeleted
                                      ? _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-danger md-just-icon md-round",
                                            attrs: { title: "delete tag" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.deleteTag(tag)
                                              },
                                            },
                                          },
                                          [_c("md-icon", [_vm._v("delete")])],
                                          1
                                        )
                                      : _vm._e(),
                                    !tag.isDeleted
                                      ? _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-warning md-just-icon md-round",
                                            attrs: { title: "edit tag" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.editTag(tag)
                                              },
                                            },
                                          },
                                          [_c("md-icon", [_vm._v("edit")])],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      ),
                      _vm.tagList.length == 0
                        ? _c("div", { staticClass: "text-center" }, [
                            _c("p", { staticClass: "no-result-message" }, [
                              _vm._v("No tags created."),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }